var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-table',{attrs:{"title":_vm.$tc('discrepancy', 2),"headers":_vm.headers,"opt":{
    company_id: _vm.company.pk
  },"app":"purchase.purchaseorderproduct","api":"purchase.pending","dontRemove":"","dontCreate":"","dontEdit":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }